import { Box, CircularProgress, styled } from '@mui/material'
import type { FC } from 'react'

const SpinnerContainer = styled(Box)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '100vh',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
})

const StyledCircularProgress = styled(CircularProgress)({
  color: '#495AFF', // Match your primary color
  width: '48px !important',
  height: '48px !important',
})

interface LoadingSpinnerProps {
  size?: number
}

export const LoadingSpinner: FC<LoadingSpinnerProps> = ({ size = 48 }) => {
  return (
    <SpinnerContainer>
      <StyledCircularProgress size={size} />
    </SpinnerContainer>
  )
}
